import React from 'react';
import { useNavigate, generatePath } from 'react-router-dom';
import { StyledNavIcon, AccentButton } from '../../../../styles/common';

const ActionButton = ({
    path,
    userData,
    id,
    buttonText,
    color = 'primary',
    onClick,
}) => {
    const navigate = useNavigate();

    if (!userData) {
        return null;
    }

    const { username } = userData;

    const handleClick = () => {
        if (onClick) onClick();
        navigate(generatePath(path, { username }));
    };

    if (userData.status === 'Disabled') {
        return null;
    }

    return (
        <AccentButton
            outline
            size="sm"
            id={id}
            color={color}
            style={{ margin: 0 }}
            onClick={handleClick}
        >
            <StyledNavIcon icon="plus-circle" />
            {buttonText}
        </AccentButton>
    );
};

export default ActionButton;
